import { getLocalStorage } from "../utils/localstorage.utils";

export const API_URL = process.env.REACT_APP_API_URL;

 
export const lang:"np"|"en" = getLocalStorage('lang') as "np"|"en" ||'np';